const enrollTranslations = {
  en: {
    pageTitle: "Enrollment",
    submitBtn: "Submit Enrollment",
    subtitle: "Fill details to enroll and pay admission fee.",
  },
  pa: {
    pageTitle: "ਦਾਖਲਾ",
    submitBtn: "ਦਾਖਲਾ ਭੇਜੋ",
    subtitle: "ਦਾਖਲਾ ਅਤੇ ਫੀਸ ਭਰਨ ਲਈ ਵੇਰਵੇ ਭਰੋ।",
  },
};

export default enrollTranslations;
